import { render, staticRenderFns } from "./Quotation_main.vue?vue&type=template&id=561d326c&scoped=true&"
import script from "./Quotation_main.vue?vue&type=script&lang=js&"
export * from "./Quotation_main.vue?vue&type=script&lang=js&"
import style0 from "./Quotation_main.vue?vue&type=style&index=0&id=561d326c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d326c",
  null
  
)

export default component.exports